import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { DateRangeStatus } from '../date-range';
import { CountdownV2Component } from '@fgb/portal-component-library/src/lib/shared/countdown-v2';

@Component({
  selector: 'fgbcl-coming-soon-reward-status',
  standalone: true,
  imports: [FGBSharedModule, CountdownV2Component],
  templateUrl: './coming-soon-reward-status.component.html',
  styleUrl: './coming-soon-reward-status.component.scss',
})
export class ComingSoonRewardStatusComponent extends DateRangeStatus {
  @Input() startDate: any;
  @Input() comingSoonDate: any;
  @Output() itemStart: EventEmitter<any> = new EventEmitter();
}
